import { $$ } from '@zimpa/dom';
import { $ } from '@zimpa/dom';

const CONTAINER_SELECTOR = '.js-accordion';
const ITEM_SELECTOR = '.js-accordion__item';
const BODY_SELECTOR = '.js-accordion__item-body';
const TRIGGER_SELECTOR = '.js-accordion__trigger';
const ACTIVE_CLASS = 'active';

class Accordion {
    private _active: HTMLElement[] | undefined;

    public constructor(container: HTMLElement) {
        $$(ITEM_SELECTOR, container).forEach((item: HTMLElement): void => {
            this.handleItem(item);
        });
    }

    private handleItem(item: HTMLElement): void {
        const trigger: HTMLElement | undefined = $(TRIGGER_SELECTOR, item);
        const body: HTMLElement | undefined = $(BODY_SELECTOR, item);

        if (trigger === undefined || body === undefined) {
            return;
        }

        const collapsable = document.createElement('div');
        const wrapper = document.createElement('div');
        collapsable.classList.add('o-collapsable')
        wrapper.classList.add('o-collapsable__animation')
        this.wrap(body, wrapper);
        this.wrap(wrapper, collapsable);

        body.classList.add('o-collapsable__transform')

        trigger.addEventListener('click', (): void => {
            this.toggle(item, trigger, body);
        });
    }

    private toggle(item: HTMLElement, trigger: HTMLElement, body: HTMLElement): void {

        if (this._active !== undefined && this._active[0] === item) {
            this._active[0].classList.remove(ACTIVE_CLASS);
            this._active[1].setAttribute('aria-expanded', 'false');
            this._active = [];

            return;
        }

        if (this._active !== undefined && this._active.length !== 0) {
            this._active[0].classList.remove(ACTIVE_CLASS);
            this._active[1].setAttribute('aria-expanded', 'false');
        }

        this._active = [item, trigger];
        this._active[0].classList.add(ACTIVE_CLASS);
        this._active[1].setAttribute('aria-expanded', 'true');
        body.focus();
    }

    private wrap(el,wrapper) {
        el.parentNode.insertBefore(wrapper, el);
        wrapper.appendChild(el);
    }

}

export function accordion(): void {
    $$(CONTAINER_SELECTOR).map(
        (element: HTMLElement): Accordion => {
            return new Accordion(element);
        },
    );
}
